import { io } from "socket.io-client";
import constants from "./utils/constants";

const URL = constants.host || "http://localhost:1107";
// const URL = "http://localhost:3031";

export const socket = io(URL);